/** Hub slide-over open timing — used by measure-hub-panel-open.mjs on staging. */
const START = 'hub-panel-open-start'
const READY = 'hub-panel-ready'
const MEASURE = 'hub-panel-open'

export function markHubPanelOpenStart(): void {
  if (typeof performance === 'undefined') return
  performance.clearMarks(START)
  performance.clearMarks(READY)
  performance.clearMeasures(MEASURE)
  performance.mark(START)
}

export function markHubPanelReady(): void {
  if (typeof performance === 'undefined') return
  performance.mark(READY)
  try {
    performance.measure(MEASURE, START, READY)
    const entry = performance.getEntriesByName(MEASURE).pop()
    if (entry) {
      ;(window as Window & { __hubPanelOpenMs?: number }).__hubPanelOpenMs = Math.round(entry.duration)
    }
  } catch {
    /* start mark missing */
  }
}

export function readHubPanelOpenMs(): number | null {
  if (typeof window === 'undefined') return null
  const ms = (window as Window & { __hubPanelOpenMs?: number }).__hubPanelOpenMs
  return typeof ms === 'number' && Number.isFinite(ms) ? ms : null
}
